module.exports = __webpack_public_path__ + "static/scale-model-of-topeka-kansas-91d19e0bc49144218a1dce55918c73af.png";